<template>
  <FeathersServiceTable service="cases" :params="casesParams" :headers="tableHeaders" :limit="10">
    <template #item.name="{ item }">
      <router-link
        :to="{
          name: 'CaseInput',
          params: { scenario: item.scenario, id: item.id },
        }"
      >
        {{ item.name }}
      </router-link>
    </template>
    <template #item.deleted="{ item }">
      <span>{{ formatDate(item.deleted) }}</span>
    </template>
    <template #item.directory_id="{ item }">
      <FeathersVuexGet
        v-if="item.directory_id !== null"
        v-slot="{ item: folder }"
        service="directories"
        :id="item.directory_id"
      >
        <router-link
          v-if="folder"
          :to="{ name: 'Folders', params: { folderId: item.directory_id } }"
        >
          {{ folder.name }}
        </router-link>
        <span v-else>Loading...</span>
      </FeathersVuexGet>
      <router-link v-else :to="{ name: 'Folders' }"> Root Folder </router-link>
    </template>
    <template #item.actions="{ item }">
      <v-tooltip top>
        <template #activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" icon @click="restoreCase(item.id)"
            ><v-icon>mdi-delete-restore</v-icon></v-btn
          >
        </template>
        <span>Restore</span>
      </v-tooltip>
    </template>
  </FeathersServiceTable>
</template>

<script>
import { paramsForServer } from "feathers-hooks-common";
import { DateTime } from "luxon";
import { mapActions } from "vuex";

export default {
  name: "RecycleBin",
  components: {
    FeathersServiceTable: () => import("@/components/FeathersServiceTable.vue"),
  },
  mixins: [],
  props: {},
  data() {
    return {
      tableHeaders: [
        {
          text: "Name",
          value: "name",
          width: "40%",
        },
        {
          text: "Deleted",
          value: "deleted",
          width: "20%",
        },
        {
          text: "Original location",
          value: "directory_id",
          sortable: false,
          width: "20%",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          width: "20%",
        },
      ],
    };
  },
  computed: {
    casesParams() {
      return paramsForServer(
        {
          query: {
            $select: ["id", "name", "deleted", "directory_id"],
            deleted: { $ne: null },
          },
          disableSoftDelete: true,
        },
        "disableSoftDelete"
      );
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    ...mapActions({
      patchCase: "cases/patch",
    }),
    restoreCase(caseId) {
      return this.patchCase([
        caseId,
        { deleted: null },
        paramsForServer({ disableSoftDelete: true }, "disableSoftDelete"),
      ]);
    },
    formatDate(date) {
      return date
        ? DateTime.fromISO(date).toLocaleString(DateTime.DATETIME_SHORT)
        : "No date registered";
    },
  },
};
</script>
